import keyboardFocus from 'keyboard-focus';
import { initScroll } from './smooth-scroll';
export default () => {
  keyboardFocus(document);
  initScroll();
};